import {
    CreateFlowRequestDto,
    DeleteFlowFromPeriodDto,
    FlowResponseDto,
    UpdateFlowDto,
} from '../interfaces/flow';
import { request } from './Request';

/**
 * Servicio para manejar operaciones CRUD de flujos menstruales
 * Utiliza la clase Request para comunicarse con la API
 */
class FlowService {
    private readonly baseEndpoint = '/flujos';

    /**
     * Obtiene todos los flujos de un usuario específico
     * @param payload - Datos del usuario para filtrar flujos
     * @returns Lista de flujos del usuario
     */
    async getFlujosByUser(id_usuario: number): Promise<FlowResponseDto> {
        try {
            const response = await request.get<FlowResponseDto>(
                `${this.baseEndpoint}/all/${id_usuario}`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener flujos del usuario:', error);
            throw new Error('No se pudieron obtener los flujos del usuario');
        }
    }

    /**
     * Obtiene un flujo específico por su ID
     * @param payload - Datos con el ID del flujo a obtener
     * @returns Datos del flujo
     */
    async getFlowByIdPeriodo(id_periodo: number): Promise<FlowResponseDto> {
        try {
            const response = await request.get<FlowResponseDto>(
                `${this.baseEndpoint}/de-periodo/${id_periodo}`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener el periodo:', error);
            throw new Error('No se pudo obtener el periodo');
        }
    }

    /**
     * Crea un nuevo periodo menstrual
     * @param payload - Datos del nuevo periodo
     * @returns periodo creado
     */
    async createFlowOfPeriod(payload: CreateFlowRequestDto): Promise<FlowResponseDto> {
        try {
            const response = await request.post<FlowResponseDto>(
                `${this.baseEndpoint}/create`,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error al crear el flujo para el periodo:', error);
            throw new Error('No se pudo crear el flujo para el periodo');
        }
    }

    /**
     * Actualiza parcialmente un flujo de un periodo existente
     * @param payload - Datos parciales para actualizar el flujo
     * @returns Flujo actualizado
     */
    async updateFlow(payload: UpdateFlowDto): Promise<FlowResponseDto> {
        try {
            const response = await request.patch<FlowResponseDto>(
                `${this.baseEndpoint}/update-flujo-periodo`,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error al actualizar parcialmente el periodo:', error);
            throw new Error('No se pudo actualizar el periodo');
        }
    }

    /**
     * Elimina un flujo por su ID
     * @param payload - Datos con el ID del flujo a eliminar
     * @returns Confirmación de eliminación
     */
    async deleteFlow(payload: DeleteFlowFromPeriodDto): Promise<FlowResponseDto> {
        try {
            const response = await request.delete<FlowResponseDto>(
                `${this.baseEndpoint}/remove`,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error al eliminar el periodo:', error);
            throw new Error('No se pudo eliminar el periodo');
        }
    }



    //** CATALOGO de FLUJOS */
    async getFlows(): Promise<FlowResponseDto> {
        try {
            const response = await request.get<FlowResponseDto>(
                `/catalogos/flujo/all`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener el periodo:', error);
            throw new Error('No se pudo obtener el periodo');
        }
    }
}

// Exportar instancia singleton
export const flowService = new FlowService();

// Exportar la clase para crear instancias personalizadas si es necesario
export default FlowService;